import {z} from 'zod'

export type StripeSubscriptionId = `sub_${string}`
export const StripeSubscriptionId = z.string().startsWith('sub_') as z.ZodType<StripeSubscriptionId>
